const helpMap: Record<string, string> = {
  '/': 'dashboard.md',
  '/help': 'support.md',
  '/changelog': 'support.md',
  '/feedback': 'support.md',
  '/login': 'auth.md',
  '/auth/callback': 'auth.md',
  '/checkin': 'auth.md',
  '/onboarding': 'auth.md',
  '/chemicals': 'chemicals.md',
  '/chemical-products/:slug': 'chemicals.md',
  '/projects': 'projects.md',
  '/projects/new': 'projects.md',
  '/projects/:id': 'projects.md',
  '/project/:id': 'projects.md',
  '/projects/:id/organization': 'projects.md',
  '/planner': 'projects.md',
  '/resourceplanner': 'projects.md',
  '/planning/overview': 'projects.md',
  '/planning/shifts': 'projects.md',
  '/planning/shifts/templates': 'projects.md',
  '/documents': 'documents.md',
  '/projectfolders': 'documents.md',
  '/permits': 'permits.md',
  '/permits/new': 'permits.md',
  '/permits/:id': 'permits.md',
  '/search': 'support.md',
  '/customers': 'parties.md',
  '/customers/new': 'parties.md',
  '/customers/:id': 'parties.md',
  '/vendors': 'parties.md',
  '/vendors/new': 'parties.md',
  '/vendors/:id': 'parties.md',
  '/vendors/:id/assessments': 'parties.md',
  '/contacts': 'parties.md',
  '/contacts/new': 'parties.md',
  '/contacts/:id': 'parties.md',
  '/time': 'time.md',
  '/time/overview': 'time.md',
  '/time/approval': 'time.md',
  '/stafflogs': 'time.md',
  '/users': 'hr-admin.md',
  '/users/new': 'hr-admin.md',
  '/users/:id': 'hr-admin.md',
  '/employees': 'hr-admin.md',
  '/employees/new': 'hr-admin.md',
  '/employees/:id': 'hr-admin.md',
  '/leave': 'hr-admin.md',
  '/leave/approvals': 'hr-admin.md',
  '/leave/calendar': 'hr-admin.md',
  '/leave/seasons': 'hr-admin.md',
  '/leave/balances': 'hr-admin.md',
  '/leave/delegations': 'hr-admin.md',
  '/leave/blackouts': 'hr-admin.md',
  '/leave/wage-types': 'hr-admin.md',
  '/wagetypes': 'hr-admin.md',
  '/finance': 'finance.md',
  '/budgets': 'finance.md',
  '/calculations': 'finance.md',
  '/chartofaccounts': 'finance.md',
  '/vattypes': 'finance.md',
  '/purchases': 'finance.md',
  '/items': 'finance.md',
  '/purchaseorders/:id': 'finance.md',
  '/invoicebases/:id': 'finance.md',
  '/company': 'settings.md',
  '/settings': 'settings.md',
  '/settings/projectfolders': 'settings.md',
  '/categories': 'settings.md',
  '/classification-codes': 'settings.md',
  '/resourcetypes': 'settings.md',
  '/resourcegroups': 'settings.md',
  '/units': 'settings.md',
  '/resources': 'settings.md',
  '/session-audit': 'settings.md',
  '/admin/sharepoint-debug': 'settings.md',
  '/emailsettings': 'settings.md',
  '/timeentrysettings': 'settings.md',
  '/emailtemplates': 'settings.md',
  '/emaillogs': 'settings.md',
}

export default helpMap